export var getActiveElement = function (doc) {
  var ae = doc.activeElement;
  while (ae === null || ae === void 0 ? void 0 : ae.shadowRoot) {
    ae = ae.shadowRoot.activeElement;
  }
  return ae;
};